/**
 * Shared VOPRF types and constants
 */

import { Oprf } from '@cloudflare/voprf-ts';

/**
 * VOPRF suite (P256-SHA256)
 */
export type SuiteID = (typeof Oprf.Suite)[keyof typeof Oprf.Suite];
export const VOPRF_SUITE: SuiteID = Oprf.Suite.P256_SHA256;

/**
 * VOPRF key record (from configuration)
 */
export interface VoprfKeyRecord {
  sk: string; // base64url private key
  pk: string; // base64url public key
  suite: 'VOPRF-P256-SHA256';
}

/**
 * VOPRF evaluation result
 */
export interface VoprfEvaluationResult {
  evaluated: string; // base64url
  proof: string; // base64url
  serverPubKey: string; // base64url
}
